import Swiper from 'swiper'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

// グローバル関数として定義
window.showHighlight = function (id) {
  const el = document.getElementById(id)
  if (el) el.style.opacity = '1'
}

window.hideHighlight = function (id) {
  const el = document.getElementById(id)
  if (el) el.style.opacity = '0'
}

window.addEventListener('load', function () {
  const element = document.querySelector('main')
  if (!element || !element.classList.contains('top')) return

  const swiperMv = document.querySelector('.mv_slider')
  const swiperBanner = document.querySelector('.banner_slider')
  const swiperResults = document.querySelector('.results_slider')

  if (swiperMv) {
    const swiper = new Swiper(swiperMv, {
      modules: [Autoplay, Pagination],
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
  }
  if (swiperBanner) {
    const swiper = new Swiper(swiperBanner, {
      modules: [Autoplay, Navigation],
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 17,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
  if (swiperResults) {
    const swiper = new Swiper(swiperResults, {
      modules: [Autoplay, Navigation],
      loop: true,
      loopedSlides: 24,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 25,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
})
